export default __webpack_public_path__ + "static/media/Group502-tata-neu.0e689c3d.png";